import { Box, Button, Dialog, DialogContent, DialogTitle, TextField } from '@mui/material'
import { Controller, FormProvider, useForm } from 'react-hook-form';
import PaperDraggable from '../PaperDraggable';
import { formatarTelefone } from '../../helpers/masks';
import { useMutation } from 'react-query';
import axiosClient from '../../lib/axios';

export default function DialogConfiguracaoWhatsapp({
  open,
  mensagem,
  tipo_publico,
  codigo_publico,
  onClose
}: DialogConfiguracaoWhatsappProps) {

  const methods = useForm<TConfiguracaoWhatsapp>({
    defaultValues: {
      numero: '',
      mensagem: mensagem
    }
  })
  const { handleSubmit, watch, control } = methods;

  //Querys e Mutations
  const { mutate: enviarMensagem, isLoading } = useMutation({
      mutationKey: "compartilhar-recibo-email",
      mutationFn: (data: TConfiguracaoWhatsapp) =>
        axiosClient.post("/enviar-notificacao", {
          destinatario: data.numero,
          mensagem: data.mensagem,
          tipo_publico,
          codigo_publico,
          assunto: 'Compartilhamento via WhatsApp'
        }),
      onSuccess: () => {
        onClose();
      },
      onError: (error) => {
        console.error("Erro ao enviar o e-mail:", error);
      },
    });

  const onSubmit = (data: TConfiguracaoWhatsapp) => {
    enviarMensagem(data);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Configuração da mensagem</DialogTitle>
      <FormProvider {...methods}>
        <DialogContent>
          <Box component={'form'} display={'flex'} flexDirection={'column'} gap={2} >
            <Controller
              name="numero"
              control={control}
              rules={{ required: 'Campo obrigatório' }}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  label="Número do WhatsApp"
                  required
                  variant="outlined"
                  value={formatarTelefone(watch('numero'))}
                  sx={{ mt: 2 }}
                  fullWidth
                  error={invalid}
                  helperText={error?.message || ""}
                />
              )}
            />
            <Controller
              name="mensagem"
              control={control}
              rules={{ required: 'Campo obrigatório' }}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  defaultValue={mensagem}
                  label="Mensagem*"
                  variant="outlined"
                  sx={{ mt: 2 }}
                  multiline
                  fullWidth
                  error={invalid}
                  helperText={error?.message || ""}
                />
              )}
            />
            <Box
              width={'100%'}
              display={'flex'}
              justifyContent={'flex-end'}
              gap={2}
            >
              <Button
                variant='outlined'
                onClick={onClose}
                disabled={isLoading}
              >
                Cancelar
              </Button>
              <Button
                variant='contained'
                onClick={handleSubmit(onSubmit)}
                disabled={isLoading}
              >
                Enviar
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </FormProvider>
    </Dialog>
  )
}

interface DialogConfiguracaoWhatsappProps {
  open: boolean;
  mensagem?: string;
  tipo_publico?: string;
  codigo_publico?: string;
  onClose: () => void;
}


type TConfiguracaoWhatsapp = {
  numero: string;
  mensagem: string;
}
